import React, { memo, type PropsWithChildren } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import Animated, { FadeIn } from 'react-native-reanimated';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPromptContainer = memo((props: PropsWithChildren) => {
  return (
    <Animated.View style={styles.outerContainer} entering={FadeIn.duration(theme.transitions.long)}>
      <ScrollView
        style={styles.container}
        contentContainerStyle={styles.contentContainer}
        bounces={false}
      >
        {props.children}
      </ScrollView>
    </Animated.View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors.KALE,
  },
  contentContainer: {
    flexGrow: 1,
  },
});
